import React, { useEffect, useState } from "react";

import ReactExport from "react-data-export";

import Btn from "../../../components/buttons/Btn";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

const ExportExcel = ({ rowsToExport = [], disabled = false }) => {
  const [dataExcel, setDataExcel] = useState([]);
  const [styleButton, setStyleButton] = useState({});

  useEffect(() => {
    setStyleButton({ display: "none" });

    const allColumns = [
      { name: "CNPJ/CPF", keys: ["ClienteCNPJ"], alignment: "left" },
      {
        name: "Razão",
        keys: ["Razao"],
        alignment: "left",
        width: 40,
      },
      {
        name: "Produto",
        keys: ["Produto"],
        alignment: "center",
        width: 22,
      },
      {
        name: "Versão",
        keys: ["Versao"],
        alignment: "center",
        width: 22,
      },
      {
        name: "Rota",
        keys: ["Rota"],
        alignment: "center",
        width: 22,
      },
      {
        name: "CreatedAt",
        keys: ["createdAt"],
        alignment: "center",
        width: 22,
      },
    ];

    const data = rowsToExport.map((item) => {
      return allColumns.map((object) => {
        const value = item[object.keys[0]];

        return value
          ? {
              value,
              style: {
                alignment: {
                  vertical: "center",
                  horizontal: object.alignment,
                },
              },
            }
          : { value: "" };
      });
    });

    const styleColumns = {
      font: { color: { rgb: "ffffff" }, bold: true },
      fill: { fgColor: { rgb: "212121" } },
      alignment: { vertical: "center", horizontal: "center" },
    };

    const columns = allColumns.map((object) => {
      return {
        title: object.name,
        width: { wch: object.width || 15 },
        style: styleColumns,
      };
    });

    setDataExcel([{ columns, data }]);
    setStyleButton({});
  }, [rowsToExport]);

  return (
    <ExcelFile
      filename={`MapasSemContrato`}
      element={
        <Btn
          height="52px"
          bg-color="green"
          style={styleButton}
          label="Exportar"
          disabled={disabled}
        />
      }
    >
      <ExcelSheet dataSet={dataExcel} name={`MapasSemContrato`}></ExcelSheet>
    </ExcelFile>
  );
};

export default ExportExcel;
